import { useFeatureFlag } from '@newfront-insurance/admin-ui';

import { useCanViewNovaAnalytics } from './use-can-view-nova-analytics';
import { NOVA_SCHEDULES_FEATURE_FLAG } from '../../../lib/nova-schedule-proposal';
import { useChatOverlayContext, type ChatSettingsSection } from '../contexts/chat-overlay-context';

export function useActiveSettingsSection(): ChatSettingsSection {
  const { settingsSection } = useChatOverlayContext();
  const isNovaSkillsEnabled = useFeatureFlag('nova-skills', false);
  const areNovaSchedulesEnabled = useFeatureFlag(NOVA_SCHEDULES_FEATURE_FLAG, false);
  const canViewAnalytics = useCanViewNovaAnalytics();

  if (settingsSection === 'analytics' && canViewAnalytics) return 'analytics';
  if (settingsSection === 'skills' && isNovaSkillsEnabled) return 'skills';
  if (settingsSection === 'scheduled' && areNovaSchedulesEnabled) return 'scheduled';
  return 'general';
}
